import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import { DocumentosReporte, EncApi, LasMonedas, TiposExportacion } from '../Comunes/Listas';
import { useAuth } from '../contextos/AuthProvider'
import { useNavigate } from 'react-router-dom';
import { Chart } from 'react-google-charts';

const Reportes = () => {
    const [chartData, setChartData] = React.useState([]);
    const { PerfilUsuario, Token } = useAuth();
    const [Gestor, setGestor] = React.useState(null);
    const Modificar = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'Moneda':
                RefrescaTabla(value);
                break;
            default:
                setGestor((prevState) => ({
                    ...prevState,
                    [name]: value
                }));
        }
    }

    const navigate = useNavigate();
    const DatosIniciales = async () => {
        const URL = 'https://smartfecr.com:2020/SmartContrackBack/api/SmartFeCr/IniciandoReportes?bdCia=' + PerfilUsuario.BD + '&moneda=CRC';
        console.log(URL);
        const response = await fetch(URL, EncApi(Token));
        const data = await response.json();
        setGestor(data);
        ConstruirTabla(data.DashBore);
    }
    const RefrescaTabla = async (Moneda) => {
        const URL = 'https://smartfecr.com:2020/SmartContrackBack/api/SmartFeCr/SoloDashBore?bdCia=' + PerfilUsuario.BD + '&moneda=' + Moneda;
        const response = await fetch(URL, EncApi(Token));
        const data = await response.json();
        setGestor((prevState) => ({
            ...prevState,
            DashBore: data,
            Moneda: Moneda
        }));
        ConstruirTabla(data);
    }

    const ConstruirTabla = (data) => {
        //console.log(data);
        const agrupados = data.reduce((acc, item) => {
            if (!acc[item.Periodo]) {
                acc[item.Periodo] = {};
            }
            if (!acc[item.Periodo][item.Tipo]) {
                acc[item.Periodo][item.Tipo] = 0;
            }
            acc[item.Periodo][item.Tipo] += item.Monto;
            return acc;
        }, {});

        // Crear el formato para Google Charts
        const encabezados = ['Período', ...new Set(data.map(item => item.Tipo))];
        const filas = Object.entries(agrupados).map(([periodo, tipos]) => {
            const valores = encabezados.slice(1).map(tipo => tipos[tipo] || 0);
            return [periodo, ...valores];
        });

        setChartData([encabezados, ...filas]);
    }

    const handleOnSubmit = (e) => {
        e.preventDefault();
    }
    const Salir = () => {
        navigate("/");
    }
    const GenerarReporte = async () => {
        const URL = Gestor.Formatos !=='XLS' ? 'https://smartfecr.com:2017/api/Reportes/ReportesGenerales?BDCompania='
            + PerfilUsuario.BD
            + '&IdCia=' + PerfilUsuario.IdCia
            + '&Doc=' + Gestor.Doc
            + '&Formato=' + Gestor.Formatos
            + '&Desde=' + Gestor.txtDel
            + '&Hasta=' + Gestor.txtAl :'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/ExcelReportes?IdCia=' + PerfilUsuario.IdCia + '&BdCia='
            + PerfilUsuario.BD
            + '&CboTipDoc=' + Gestor.Doc
            + '&FecDesde=' + Gestor.txtDel
            + '&FecHasta=' + Gestor.txtAl;
        console.log(URL);
        Swal.fire({
            title: 'Generando reporte...',
            text: 'Por favor, espere mientras se genera el documento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        try {
            const response = await fetch(URL , Gestor.Formatos ==='XLS' ? EncApi(Token) : {method: 'GET' });
            const data = await response.json();
            console.log(data);
            let ElArchivo='';
            if (Gestor.Formatos ==='XLS') {
                if (data.Codigo ===0) {
                    ElArchivo = data.Mensaje;
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: data.Mensaje,
                    });
                    return;
                }
            } else {
                ElArchivo = data.Result;
            }
            // Determinar el tipo MIME y la extensión del archivo
            let mimeType = '';
            let fileExtension = '';

            switch (Gestor.Formatos) {
                case 'PDF':
                    mimeType = 'application/pdf';
                    fileExtension = '.pdf';
                    break;
                case 'XLS': //Excel Sin Formato
                    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    fileExtension = '.xlsx';
                    break;
                case 'XLSS'://Excel Con Formato
                    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    fileExtension = '.xls';
                    break;
                case 'DOC':
                    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    fileExtension = '.doc';
                    break;
                default:
                    console.error('Formato no soportado:', Gestor.Formatos);
                    return;
            }

            // Crear y descargar el archivo
            const tempLink = document.createElement('a');
            tempLink.href = `data:${mimeType};base64,${ElArchivo}`;
            tempLink.setAttribute('download', 'Reporte_' + Gestor.Doc + fileExtension);
            tempLink.click();
            Swal.close();

        } catch (error) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo generar el reporte.',
                confirmButtonText: 'Aceptar'
            });
        }
    }


    useEffect(() => {
        DatosIniciales();
        // eslint-disable-next-line
    }, []);

    if (PerfilUsuario && Gestor) {
        return (

            <div className='main-block'>
                <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                    <div className='formadoShadow'>

                        <div className='tituloPantalla'>
                            <p style={{ display: 'inline-block' }}> Reportes SmartFE</p>
                            <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                        </div>

                        <div className='row'>
                            <div className="col-25">
                                <span className="col-form-span">Nombre Reporte </span>
                                <select id="Doc" name="Doc" className="form-group"
                                    onChange={Modificar} value={Gestor.Doc}>
                                    {DocumentosReporte.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-25">
                                <span className="col-form-span">Del día </span>
                                <input type="date" id="txtDel" onChange={Modificar} name="txtDel"
                                    value={Gestor.txtDel}></input>
                            </div>
                            <div className="col-25">
                                <span className="col-form-span">Al día </span>
                                <input type="date" id="txtAl" onChange={Modificar} name="txtAl"
                                    value={Gestor.txtAl}></input>
                            </div>
                            <div className='col-25'>
                                <span className="col-form-span">Formato </span>
                                <select id="Formatos" name="Formatos" className="form-group"
                                    onChange={Modificar} value={Gestor.Formatos}>
                                    {TiposExportacion.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-25'>
                                <button className="boton" id="btnGenerar" onClick={() => GenerarReporte()} name="btnGenerar">Generar</button>
                            </div>
                            <div className='col-75'>

                            </div>
                        </div>

                        <div name="grafico" style={{ marginTop: '20px' }}>
                            {chartData.length > 0 && (
                                <Chart
                                    chartType="ColumnChart"
                                    width="100%"
                                    height="500px"
                                    data={chartData}
                                    options={{
                                        title: 'Documentos por Período',
                                        hAxis: { title: 'Período', titleTextStyle: { color: '#333' } },
                                        vAxis: { minValue: 0 },
                                        isStacked: true,
                                    }}
                                />
                            )}
                        </div>
                        <div className='row'>
                            <div className='col-25'>
                                <select id="Moneda" name="Moneda" className="form-group"
                                    onChange={Modificar} value={Gestor.Moneda}>
                                    {LasMonedas.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-75'>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f9f9f9',
                fontFamily: 'Arial, sans-serif',
                color: '#555',
                textAlign: 'center'
            }}>
                <div>
                    <p style={{
                        fontSize: '18px',
                        marginBottom: '10px'
                    }}>Cargando Información...</p>
                    <p style={{
                        fontSize: '14px',
                        color: '#888'
                    }}>Por favor, espere mientras se cargan los datos necesarios.</p>
                </div>
            </div>
        );
    }
};

export default Reportes;